var exports = {
  "n": "xfd349460--abdb9a--link",
};

module.exports = exports;
